import { createSelector } from 'reselect'

import { groupBy } from 'util/arrays'

import selectIntegrationCredentials from './selectIntegrationCredentials'

export default createSelector(
  selectIntegrationCredentials,
  integrationCredentials =>
    groupBy(integrationCredentials, ({ provider }) => provider)
)
